import React, { useCallback } from 'react';
import { Box, Stack, alpha } from '@mui/material';

import { Button, Typography } from '@occc-app/design-system';

interface IOfferTypeSelectedItemProps {
  title: string;
  isChangeButtonVisible?: boolean;
  description: string;
  icon: React.ComponentType;
  onClick: (type: null) => void;
}

export const OfferTypeSelectedItem: React.FC<IOfferTypeSelectedItemProps> = ({
  title,
  description,
  isChangeButtonVisible,
  onClick,
  icon: Icon,
}) => {
  const handleClick = useCallback(() => {
    onClick(null);
  }, [onClick]);

  return (
    <Stack
      direction='row'
      alignItems='center'
      spacing={2}
      px={2}
      py={4}
      display='flex'
      borderRadius='4px'
      sx={({ palette }) => ({ bgcolor: alpha(palette.primary.main, 0.2) })}
      mb={2}
    >
      <Box color='primary.main'>
        <Icon />
      </Box>
      <Box flex={1}>
        <Typography variant='subtitle1' component='p' color='inherit'>
          {title}
        </Typography>
        <Typography variant='body2' component='p' color='inherit'>
          {description}
        </Typography>
      </Box>
      {isChangeButtonVisible && (
        <Button onClick={handleClick} color='primary'>
          Change
        </Button>
      )}
    </Stack>
  );
};
